// extracted by mini-css-extract-plugin
module.exports = {"component":"NoItems_component__VAQQj"};